/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { FC } from "react";
import { IconRenderProps } from "@/src/types/IconRenderProps.ts";
import { useTheme } from "@mui/material/styles";
import { Box } from "@mui/material";
import { mergeSx } from "@/src/utils/mergeSx.ts";
import { iconStyle } from "@/src/components/Icon/iconStyle.ts";

export type IconProps = {
  active?: boolean;
  icon: FC<IconRenderProps>;
  variant?: "standard" | "bordered";
  fill?: string;
};

export default function Icon({ active, icon: Icon, variant = "standard", fill }: IconProps) {
  const theme = useTheme();

  const isBordered = variant === "bordered";

  let iconFill = active ? theme.palette.primary.contrastText : theme.palette.primary.main;

  if (fill) {
    iconFill = fill
  }

  return (
    <Box aria-hidden="true" sx={mergeSx(iconStyle.container, isBordered && iconStyle.bordered, isBordered && active && iconStyle.borderedActive)}>
      <Icon fill={iconFill} />
    </Box>
  );
}
